import React, { useState, useEffect } from "react";
import MPHomeFirstBlock from "./BarberMainPageComps/MPHomeFirstBlock";
import MPHomeShowImages from "./BarberMainPageComps/MPHomeShowImages";
import MPHomeBookApp from "./BarberMainPageComps/MPHomeBookApp";
import MPHomeModalMakeApp from "./BarberMainPageComps/MPHomeModalMakeApp";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";
import MPHomeSecondBlock from "./BarberMainPageComps/MPHomeSecondBlock";
import WorkHoursPage from "./BarberMainPageComps/WorkHoursPage";
import MPHomeShowProducts from "./BarberMainPageComps/MPHomeShowProducts";

export default function MPHome() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t, i18n } = useTranslation();

  const {
    OpenDrawer,
    setOpenDrawer,
    setAllApps,
    Loading,
    setLoading,
    setChoosedDate,
    setChoosedApps,
    AllData,
    setAllData,
    setUser,
    User,
    setAppContextLoading,
    AppContextLoading,
    OtherBarbers,
    setOtherBarbers,
    refreshDataCallback,
    setValue,
    value,
    AllowUsersBookApp,
    setAllowUsersBookApp,
    Lang,
    setLang,
  } = useAppContext();
  const lang = JSON.parse(localStorage.getItem("lang"));
  const [Choosing, setChoosing] = useState(lang);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const renderStars = (rating) => {
    return (
      <div style={{ display: "flex", gap: "4px" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <svg
            key={star}
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill={star <= rating ? "#FCD34D" : "#E5E7EB"}
            stroke={star <= rating ? "#F59E0B" : "#D1D5DB"}
            strokeWidth="1"
          >
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        ))}
      </div>
    );
  };

  const calculateAverageRating = () => {
    if (!AllData?.allReviews || AllData.allReviews.length === 0) return 0;
    const sum = AllData.allReviews.reduce(
      (acc, review) => acc + review.rating,
      0,
    );
    return (sum / AllData.allReviews.length).toFixed(1);
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Simplified background decoration */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "400px",
          background:
            "linear-gradient(180deg, rgba(201,168,76,0.04) 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Download App Modal */}
      {showDownloadModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
            backdropFilter: "blur(8px)",
          }}
          onClick={() => setShowDownloadModal(false)}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "32px 24px",
              maxWidth: "480px",
              width: "100%",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              position: "relative",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowDownloadModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#f3f4f6",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6b7280"
                strokeWidth="2"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <div
              style={{
                width: "80px",
                height: "80px",
                margin: "0 auto 20px",
                background: "linear-gradient(135deg, #1A1A2E 0%, #16213E 100%)",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(201, 168, 76, 0.25)",
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
              >
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
            </div>

            <h2
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#1a1a1a",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              {t("WantYourOwnBusinessApp") || "Want Your Own Business?"}
            </h2>

            <p
              style={{
                fontSize: "15px",
                color: "#6b7280",
                textAlign: "center",
                margin: "0 0 24px 0",
                lineHeight: "1.5",
              }}
            >
              {t("DownloadBokahitBusinessForBusinessOwners") ||
                "Download Bokahit Business and start managing your business today!"}
            </p>

            <div
              style={{
                backgroundColor: "#f9fafb",
                borderRadius: "12px",
                padding: "16px",
                marginBottom: "20px",
              }}
            >
              {[
                {
                  icon: "📅",
                  text: t("ManageAppointments") || "Manage appointments",
                },
                { icon: "👥", text: t("TrackCustomers") || "Track customers" },
                {
                  icon: "💰",
                  text: t("IncreaseRevenue") || "Increase revenue",
                },
                {
                  icon: "📊",
                  text: t("BusinessAnalytics") || "Analytics & reports",
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: index < 3 ? "12px" : "0",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{feature.icon}</span>
                  <span style={{ fontSize: "14px", color: "#374151" }}>
                    {feature.text}
                  </span>
                </div>
              ))}
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <button
                onClick={() => {
                  window.open(
                    "https://apps.apple.com/us/app/bokahitbusiness/id6759691684",
                    "_blank",
                  );
                }}
                style={{
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "2px solid #000000",
                  backgroundColor: "#000000",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  transition: "transform 0.2s ease",
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                App Store
              </button>

              <button
                onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.mohammad1998a.bokahitbusiness",
                    "_blank",
                  );
                }}
                style={{
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "2px solid #000000",
                  backgroundColor: "#000000",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  transition: "transform 0.2s ease",
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                Google Play
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div style={{ position: "relative", zIndex: 1 }}>
        <MPHomeFirstBlock />

        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px 120px",
          }}
        >
          {/* Gallery Section */}
          <section
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              marginTop: "-30px",
              position: "relative",
              zIndex: 2,
              overflow: "hidden",
            }}
          >
            <MPHomeShowImages />
            <WorkHoursPage />
            <MPHomeShowProducts />
          </section>

          {/* CLEAR BOOKING SECTION - PRIORITY DESIGN */}
          {AllowUsersBookApp === 1 ? (
            <section
              data-booking-section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                marginTop: "20px",
                padding: "0",
                position: "relative",
                overflow: "hidden",
                scrollMarginTop: "20px",
              }}
            >
              {/* Clear Header with Visual Emphasis */}
              {/* <div
                style={{
                  background:
                    "linear-gradient(135deg, #1A1A2E 0%, #16213E 100%)",
                  padding: "24px",
                  color: "white",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                  </div>
                  <h2
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      margin: 0,
                      letterSpacing: "-0.3px",
                    }}
                  >
                    {t("BookYourAppointment") || "Book Your Appointment"}
                  </h2>
                </div>
                <p
                  style={{
                    fontSize: "14px",
                    margin: 0,
                    opacity: 0.95,
                    fontWeight: "400",
                  }}
                >
                  {t("ChoosePreferredDateTime") ||
                    "Choose your preferred date and time"}
                </p>
              </div> */}

              {/* Booking Component with Clear Padding */}
              <div style={{ padding: "5px" }}>
                <MPHomeBookApp />
              </div>
              {/* <MPHomeSecondBlock /> */}
            </section>
          ) : (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                marginTop: "20px",
                padding: "40px 24px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "64px",
                  height: "64px",
                  margin: "0 auto 20px",
                  background:
                    "linear-gradient(135deg, #1A1A2E 0%, #16213E 100%)",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>

              <h2
                style={{
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                  margin: "0 0 12px 0",
                }}
              >
                {t("OnlineBookingComingSoon") || "Online Booking Coming Soon"}
              </h2>

              <p
                style={{
                  fontSize: "15px",
                  color: "#6b7280",
                  margin: "0 0 24px 0",
                  lineHeight: "1.6",
                }}
              >
                {t("InTheMeantime") || "In the meantime, contact us directly:"}
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                {[
                  { label: t("SMS") || "SMS", color: "#C9A84C" },
                  { label: t("PhoneCall") || "Call", color: "#C9A84C" },
                  { label: t("WhatsApp") || "WhatsApp", color: "#25D366" },
                ].map((contact, index) => (
                  <button
                    key={index}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "10px",
                      border: `2px solid ${contact.color}`,
                      backgroundColor: "#ffffff",
                      color: contact.color,
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {contact.label}
                  </button>
                ))}
              </div>
            </section>
          )}

          {/* Reviews Section */}
          {AllData?.allReviews && AllData.allReviews.length > 0 && (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                marginTop: "20px",
                padding: "24px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
              >
                <div>
                  <h2
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      color: "#1a1a1a",
                      margin: "0 0 4px 0",
                    }}
                  >
                    {t("CustomerReviews") || "Customer Reviews"}
                  </h2>
                  <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                    {AllData.allReviews.length} {t("Reviews") || "reviews"}
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "12px 16px",
                    background: "#1A1A2E",
                    borderRadius: "12px",
                    border: `1.5px solid #C9A84C44`,
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        color: "#ffffff",
                      }}
                    >
                      {calculateAverageRating()}
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "rgba(255,255,255,0.9)",
                      }}
                    >
                      out of 5
                    </div>
                  </div>
                  {renderStars(
                    Math.round(parseFloat(calculateAverageRating())),
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                  gap: "16px",
                }}
              >
                {AllData.allReviews.map((review) => (
                  <div
                    key={review.id}
                    style={{
                      padding: "16px",
                      backgroundColor: "#f9fafb",
                      borderRadius: "12px",
                      border: "1px solid #e5e7eb",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "10px",
                          background: `linear-gradient(135deg, #C9A84C 0%, #E8B84B 100%)`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontWeight: "700",
                        }}
                      >
                        {review.userName.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#1a1a1a",
                          }}
                        >
                          {review.userName}
                        </div>
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>
                          {review.date}
                        </div>
                      </div>
                    </div>
                    {renderStars(review.rating)}
                    {review.comment && (
                      <p
                        style={{
                          fontSize: "13px",
                          color: "#374151",
                          lineHeight: "1.5",
                          margin: "10px 0 0 0",
                        }}
                      >
                        {review.comment}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>

        {/* Simplified Footer */}
        <footer
          style={{
            marginTop: "40px",
            padding: "32px 16px",
            background: "#1A1A2E",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            {/* Language Selector */}
            <div style={{ marginBottom: "24px" }}>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#ffffff",
                  marginBottom: "12px",
                }}
              >
                {t("Chooselanguage") || "Choose Language"}
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "16px",
                  flexWrap: "wrap",
                }}
              >
                {[
                  // { code: "he", label: "עברית" },
                  { code: "sv", label: "Svenska" },
                  { code: "en", label: "English" },
                  { code: "ar", label: "العربية" },
                ].map((language) => (
                  <button
                    key={language.code}
                    onClick={() => {
                      setLang(language.code);
                      changeLanguage(language.code);
                      localStorage.setItem(
                        "lang",
                        JSON.stringify(language.code),
                      );
                    }}
                    style={{
                      padding: "8px 20px",
                      borderRadius: "8px",
                      border:
                        Lang === language.code
                          ? `2px solid #C9A84C`
                          : "2px solid rgba(255,255,255,0.2)",
                      backgroundColor:
                        Lang === language.code
                          ? "rgba(201,168,76,0.18)"
                          : "transparent",
                      color: Lang === language.code ? "#C9A84C" : "rgba(255,255,255,0.75)",
                      fontSize: "14px",
                      fontWeight: Lang === language.code ? "700" : "400",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {language.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Business Owner Button */}
            <div style={{ marginBottom: "32px" }}>
              <button
                onClick={() => setShowDownloadModal(true)}
                style={{
                  padding: "14px 28px",
                  borderRadius: "12px",
                  border: "2px solid rgba(255,255,255,0.3)",
                  backgroundColor: "rgba(255,255,255,0.15)",
                  color: "#ffffff",
                  fontSize: "15px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  backdropFilter: "blur(10px)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255,255,255,0.25)";
                  e.currentTarget.style.borderColor = "#ffffff";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255,255,255,0.15)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
                {t("ForBusinessOwners") || "For Business Owners"}
              </button>
            </div>

            <div
              style={{
                fontSize: "20px",
                fontWeight: "700",
                color: "#ffffff",
                marginBottom: "8px",
              }}
            >
              Bokahit
            </div>
            <div
              style={{
                fontSize: "13px",
                color: "rgba(255,255,255,0.9)",
                marginBottom: "24px",
              }}
            >
              {t("ModernBookingSolutions") || "Modern Booking Solutions"}
            </div>

            {/* Support Contact Section */}
            <div
              style={{
                backgroundColor: "rgba(255,255,255,0.15)",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "24px",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#ffffff",
                  marginBottom: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                {t("NeedHelpOrHaveQuestions") || "Need Help or Have Questions?"}
              </div>
              <p
                style={{
                  fontSize: "13px",
                  color: "rgba(255,255,255,0.9)",
                  marginBottom: "12px",
                  margin: "0 0 12px 0",
                }}
              >
                {t("ContactOurSupportTeam") ||
                  "Contact our support team - we're here to assist you"}
              </p>
              <a
                href="https://wa.me/46790205074"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  border: "2px solid rgba(255,255,255,0.4)",
                  color: "#ffffff",
                  fontSize: "15px",
                  fontWeight: "600",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                  backdropFilter: "blur(5px)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255,255,255,0.3)";
                  e.currentTarget.style.borderColor = "#ffffff";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255,255,255,0.2)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.4)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                {t("ContactOnWhatsApp") || "Contact on WhatsApp"}
              </a>
            </div>

            <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.8)" }}>
              {t("Copyright") || "© 2026 Bokahit. All rights reserved."}
            </div>
          </div>
        </footer>
      </div>

      <MPHomeModalMakeApp />
    </div>
  );
}
